const GRADE_HEADER_ICON = require('../../assets/ChatGPT Image Jan 28, 2026, 12_32_42 AM.png');
const YELLOW_BELT_SYLLABUS_ICON = require('../../assets/belts images/ChatGPT Image Apr 10, 2026, 11_48_05 PM.png');
const GREEN_BELT_SYLLABUS_ICON = require('../../assets/belts images/Green belt image.png');
const RED_BELT_SYLLABUS_ICON = require('../../assets/belts images/Red belt image.png');
const BROWN_BELT_SYLLABUS_ICON = require('../../assets/belts images/Brown belt image.png');
const SHODAN_HO_SYLLABUS_ICON = require('../../assets/belts images/Shodan-ho belt image.png');
const FIRST_DEGREE_BELT_SYLLABUS_ICON = require('../../assets/belts images/1st degree belt image.png');
const SECOND_DEGREE_BELT_SYLLABUS_ICON = require('../../assets/belts images/2nd degree black belt image.png');

export function normalizeGradeName(name) {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

export function gradesMatchName(a, b) {
  return normalizeGradeName(a) === normalizeGradeName(b);
}

/** Syllabus belt icons — same mapping as Syllabus page headers. */
export function getSyllabusGradeIconSource(gradeName) {
  const key = normalizeGradeName(gradeName);
  if (key === 'yellow belt') return YELLOW_BELT_SYLLABUS_ICON;
  if (key === 'green belt') return GREEN_BELT_SYLLABUS_ICON;
  if (key === 'red belt') return RED_BELT_SYLLABUS_ICON;
  if (key === 'brown belt') return BROWN_BELT_SYLLABUS_ICON;
  if (key === 'shodan ho') return SHODAN_HO_SYLLABUS_ICON;
  if (key === '1st degree black belt') return FIRST_DEGREE_BELT_SYLLABUS_ICON;
  if (key === '2nd degree black belt') return SECOND_DEGREE_BELT_SYLLABUS_ICON;
  return GRADE_HEADER_ICON;
}
